/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    cancelDateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.CANCEL DATE',
        defaultMessage: 'CANCEL DATE'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    policyTypeColumn: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.POLICY #',
        defaultMessage: 'POLICY #'
    },
    initiatorColumn: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.INITIATOR',
        defaultMessage: 'INITIATOR'
    },
    cancelReason: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.CANCEL REASON',
        defaultMessage: 'CANCEL REASON'
    },
    noCancellationsFound: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.No cancellations found',
        defaultMessage: 'No cancellations found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllAgentChanges: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.VIEW ALL CANCELLATIONS',
        defaultMessage: 'VIEW ALL CANCELLATIONS'
    },
    cancellations: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReport.Cancellations',
        defaultMessage: 'Cancellations'
    }
});
